/* eslint-disable @typescript-eslint/no-floating-promises */
import { Flex } from '@chakra-ui/react'
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
import { NivelCriterioResponse } from '../../../../../interfaces'
interface BarChartProps {
  id: string
  data: NivelCriterioResponse[]
}

export const CriterioBarChart: React.FC<BarChartProps> = ({ id, data }) => {
  function GerarGrafico(): void {
    const options = {
      series: [
        {
          data: data.sort((a, b) => b.pontuacao - a.pontuacao).map(e => e.qtdUsos)
        }
      ],
      colors: data.map(e => {
        return '#1961E0'
      }),
      chart: {
        type: 'bar',
        height: data.length * 60 > 120 ? data.length * 60 : 120,
        width: 800
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val: any) {
            return val + (val > 0 ? ' usos' : ' uso')
          },
          title: {
            formatter: function () {
              return 'Qtd. usos:'
            }
          }
        }
      },
      grid: {
        show: false
      },
      legend: {
        show: false
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top'
          },
          distributed: true
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: -10,
        style: {
          colors: ['#fff']
        },
        textAnchor: 'end',
        formatter: function (val: any) {
          if (val > 0) {
            return val
          }

          return ''
        }
      },
      xaxis: {
        labels: {
          show: true,
          hideOverlappingLabels: true
        },
        categories: data.map(e => `${e.nome} (Pontuação: ${e.pontuacao})`),
        title: {
          style: {
            color: '#000',
            fontSize: '20px',
            fontWeight: 600
          }
        }
      },
      yaxis: {
        min: 0,
        labels: {
          maxWidth: 600
        }
      }
    }

    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [data])

  return <Flex id={`chart-${id}`} />
}
